<template>
  <div class="download">
    <div class="download__panel">
      <div class="download__text">{{ $t('message.profile.download.remainText') }}</div>
      <div class="download__button global_pointer" @click="download">
        <img src="@/assets/imgs/profile/icon-download.png" alt="">
        <span>{{ $t('message.profile.download.buttonText') }}</span>
      </div>
      <img class="download__close" src="@/assets/imgs/close.png" alt="close" @click="close">
    </div>
  </div>
</template>
<style lang="less">
.download {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  &__panel {
    position: absolute;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    padding-top: 50px;
  }
  &__text {
    max-width: 311px;
    margin: auto;
    margin-top: 26px;
    font-size: 20px;
    color: #333333;
    line-height: 30px;
  }
  &__button{
    margin: 11px auto 36px auto;
    width: 311px;
    height: 46px;
    border-radius: 23px;
    background: #222222;
    display: flex;
    justify-content: center;
    align-items: center;
    & img{
      width: 26px;
      height: 26px;
      margin-right: 8px;
    }
    & span{
      height: 22px;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 22px;
    }
  }
  &__close{
    width: 26px;
    height: 26px;
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
<script>
import OpenApp from '@/common/openApp';
const openApp = new OpenApp();
export default {
  name: 'Download',
  methods:{
    close(){
      this.$emit('close-download')
    },
    download(){
      openApp.download()
    }
  }
}
</script>